var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"env":_vm.env}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }